import type {
  PostSupportTicketRequestBodyType,
  PostSupportTicketResponseBodyType,
} from "@intelligems/ig-types/functions/support/post-support-ticket";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const postSupportTicket = async (
  body: PostSupportTicketRequestBodyType
): Promise<PostSupportTicketResponseBodyType> => {
  const resp = await api.post<PostSupportTicketResponseBodyType>(
    `/v2/support/ticket`,
    body
  );
  return resp.data;
};

export const usePostSupportTicket = () => {
  return useMutation({
    mutationKey: ["postSupportTicket"],
    mutationFn: postSupportTicket,
  });
};
